<div (mouseenter)="this.dotComService.DisplaySubMenu('')">

    <div class="headerImageHeight" style="background-size: cover; background-position:center;"
        [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'specag-header.jpg)'}">
        <div class="row">
            <div style="width:10%"></div>
            <div *ngIf="myHarrellsService.bootstrapViewPortSize != ''" class="text-center whiteText" style="width:80%">
                <h1 *ngIf="myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">
                    SPECIALTY AG
                </h1>
                <h1 *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">SERVING
                    THE SPECIALTY CROP FARMERS <br>WHO FEED AMERICA</h1>
            </div>
            <div style="width:10%"></div>
        </div>
        <!-- <div class="row"
            *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
            <div style="width:22%"></div>
            <div class="text-center whiteText" style="width:56%">
                <h2 class="DIN2014Regular whiteText" style="font-size:19px;line-height:30px;letter-spacing: .38px;">
                    Discover Top Products and Services from Leading Providers.</h2>
            </div>
            <div style="width:22%"></div>
        </div>
        <div class="row text-center"
            *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
            style="padding-top:3%; padding-bottom:3%">
            <h3><a class="DIN2014Bold greenBackground whiteText"
                    style="font-size:20px;font-weight:700;padding:8pt; text-decoration: none !important"
                    href='/findrep'>FIND YOUR REP</a>
            </h3>
        </div> -->
    </div>
    <div class="row whiteBackground">
        <div class="col-md-2"></div>
        <div class="col-md-8 text-center" style="padding-top:70px; padding-bottom:70px">
            <h3 class="DIN2014Regular blackText harrellsProvides">
                Harrell’s is committed to helping specialty agriculture growers optimize yields, improve crop quality,
                and protect their investment. Whether you're growing citrus, berries, watermelon, sugarcane, or other
                high-value crops, our science-backed nutrition solutions are designed to support your operation’s unique
                needs.<br> <br>As the sole United States manufacturer and distributor of POLYON® controlled-release
                fertilizer we can provide the unparalleled access to customization, technical support, and customer care
                you need for sustainable, profitable growth. Partner with Harrell’s and experience the difference that a
                true partner for success can make for your farm.</h3>
        </div>
        <div class="col-md-2"></div>
    </div>
    <div class="row cremeBackground text-center whiteText" style="margin: auto; padding-top:70px">
        <div class="text-center p-0" style="margin-top:10px; margin-bottom:10px">
            <div style="display:inline-block; ">
                <img class="topFourImages" src="{{this.pageImagePaths + 'specag1.jpg'}}" alt="golf image">
                <h4 class="DIN2014Regular whiteText topFourImagesTextOne">
                    STRAWBERRY</h4>
            </div>

            <div style="display:inline-block">
                <img class="topFourImages" src="{{this.pageImagePaths + 'specag2.jpg'}}" alt="lawn image">
                <h4 class="DIN2014Regular whiteText topFourImagesTextOne">
                    WATERMELON</h4>
            </div>

            <div style="display:inline-block">
                <img class="topFourImages" src="{{this.pageImagePaths + 'specag3.jpg'}}" alt="hort image">
                <h4 class="DIN2014Regular whiteText topFourImagesTextOne">
                    PEPPERS</h4>
            </div>

            <div style="display:inline-block">
                <img class="topFourImages" src="{{this.pageImagePaths + 'specag4.jpg'}}" alt="sports image">
                <h4 class="DIN2014Regular whiteText topFourImagesTextOne">
                    TOMATOES</h4>
            </div>
        </div>
    </div>

    <div class="row whiteBackground">
        <div class="col-md-2"></div>
        <div class="col-md-8 text-center" style="padding-top:70px;">
            <h3 class="DIN2014Bold blueText iCannotSayEnough">
                “We have used Harrell’s POLYON® Fertilizer for over 20 years. I feel like the block we had it in during
                the 2015-2016 strawberry season was one of the best blocks of strawberries in Hillsborough County,
                Florida. I stand by the product and will be using it again this year.”</h3>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-2"></div>
        <div class="col-md-8 text-center" style="padding-bottom:70px;margin-top:60px">
            <h3 class="Caecilia76BoldItalic greenText" style="font-size: 20px; letter-spacing: .48px;">
                -Matt Parke, Owner | Parkesdale Farms</h3>
        </div>
        <div class="col-md-2"></div>
    </div>

    <app-customerform></app-customerform>

    <div class="lightCremeBackground">
        <div class="row lightCremeBackground yourPartnerForSuccess" id="partnersSuccessBlock">
            <div class="col-lg-4 greenText lightCremeBackground" style="padding-right:0px; padding-left:0px">
                <h3 class="Caecilia76BoldItalic yourPartnerForSuccessDetail">
                    Harrell's Is Your<br />Partner For Success</h3>
            </div>
            <div class="col-lg-8">
                <div class="row lightCremeBackground" style="padding-right:10%;">
                    <div class="col-lg-4 blueText text-center yourPartnerForSuccessBorder">
                        <div class="margin:10px">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.pageImagePaths + 'icon-1.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText pb-5"
                                style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                PH.D'S INNOVATING
                                <br>
                                PRODUCTS AND
                                <br>
                                PROGRAMS
                            </h4>
                        </div>
                        <div class="margin:10px">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.pageImagePaths + 'icon-4.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                INVENTORY ENSURING <BR> PRODUCTS STAY <BR> STOCKED
                            </h4>
                        </div>
                    </div>
                    <div class="col-lg-4 blueText text-center" style="padding-left:20px">
                        <div class="margin:10px">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.pageImagePaths + 'icon-2.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText pb-5"
                                style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                REPS WITH <BR> FIRST-HAND FIELD <BR> EXPERIENCE
                            </h4>
                        </div>
                        <div class="margin:10px">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.pageImagePaths + 'icon-5.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                OPS & DRIVERS <BR> DELIVERING THE <BR> GOODS
                            </h4>
                        </div>
                    </div>
                    <div class="col-lg-4 blueText text-center" style="padding-left:20px">
                        <div class="margin:10px">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.pageImagePaths + 'icon-3.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText pb-5"
                                style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                IT PROVIDING <BR> PROPRIETARY <BR> TECH
                            </h4>
                        </div>
                        <div class="margin:10px;">
                            <img style="margin-top:5%; width:50px; padding-bottom:6px"
                                src="{{this.pageImagePaths + 'icon-6.png'}}" alt="account setup image">
                            <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; line-height: 1.25;">
                                CORPORATE TEAMS <BR> SUPPORTING <BR> IT ALL
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row whiteBackground text-center whiteText" style="margin: auto; padding-top:70px">
        <div class="text-center p-0" style="margin-top:10px; margin-bottom:70px">
            <div style="display:inline-block; ">
                <a href="{{ this.filePath + '/WatermelonSell.pdf'}}" target="_blank">
                <img class="fourSellImages" src="{{this.pageImagePaths + 'WatermelonSell.jpg'}}" alt="watermelon pdf">
                <h5 class="DIN2014Regular text-center"
                    style="margin-top:20px; margin-bottom:20px; color:#006890; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                    LEARN MORE ></h5>
                </a>
            </div>

            <div style="display:inline-block">
                <a href="{{ this.filePath + '/SugarcaneSell.pdf'}}" target="_blank">
                <img class="fourSellImages" src="{{this.pageImagePaths + 'SugarcaneSell.jpg'}}" alt="sugarcane pdf">
                <h5 class="DIN2014Regular text-center"
                style="margin-top:20px; margin-bottom:20px; color:#006890; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                LEARN MORE ></h5>
                </a>
            </div>

            <div style="display:inline-block">
                <a href="{{ this.filePath + '/CornSell.pdf'}}" target="_blank">
                <img class="fourSellImages" src="{{this.pageImagePaths + 'CornSell.jpg'}}" alt="corn pdf">
                <h5 class="DIN2014Regular text-center"
                style="margin-top:20px; margin-bottom:20px; color:#006890; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                LEARN MORE ></h5>
            </a>
            </div>

            <div style="display:inline-block">
                <a href="{{ this.filePath + '/CitrusSell.pdf'}}" target="_blank">
                <img class="fourSellImages" src="{{this.pageImagePaths + 'CitrusSell.jpg'}}" alt="citrus pdf">
                <h5 class="DIN2014Regular text-center"
                style="margin-top:20px; margin-bottom:20px; color:#006890; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                LEARN MORE ></h5>
            </a>
            </div>
        </div>
    </div>

    <div class="row text-center" style="background-size: cover; background-position:center; padding-bottom:5%"
        [ngStyle]="{backgroundImage: 'url(' + this.baseImagePaths + 'harrells-pattern-full.png)'}">
        <h3 class="DINNextLTPro-Black whiteText"
            style="font-size:30px; line-height:44px; text-transform: uppercase; text-align: center; margin-top:5%">
            Harrell’s is the exclusive United States owner,<br> formulator and distributor of POLYON® <br>controlled
            release
            fertilizer.</h3>
        <h3 style="margin-top:3%"><a class="DIN2014Bold whiteBackground greenText"
                style="font-size:20px ;padding:8pt; text-decoration: none !important" href='/findrep'>CONNECT WITH
                YOUR
                REP</a>
        </h3>
    </div>

    <app-blogsbymarketpage></app-blogsbymarketpage>

</div>